import React, { useState } from 'react';
import { Card, Icon, Button } from '../../common';
import { getLogColor, formatTimestamp } from '../../../utils';
import type { LogEntry } from '../../../services';

export interface LogsViewerProps {
  logs: LogEntry[];
  onClearLogs: () => void;
}

export const LogsViewer: React.FC<LogsViewerProps> = ({
  logs,
  onClearLogs
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const getLogIcon = (level: 'info' | 'warn' | 'error') => {
    switch (level) {
      case 'info':
        return 'activity';
      case 'warn':
        return 'alert-triangle';
      case 'error':
        return 'x';
    }
  };

  return (
    <Card>
      <div className="flex items-center justify-between mb-4">
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="flex items-center justify-between w-full text-left"
        >
          <h3 className="text-xl font-normal text-[#424242]">
            Logs del Sistema ({logs.length})
          </h3>
          <Icon 
            name={isExpanded ? "chevron-up" : "chevron-down"} 
            className="w-5 h-5 text-gray-500" 
          />
        </button>

        {logs.length > 0 && (
          <Button
            variant="danger"
            size="small"
            icon="trash"
            onClick={onClearLogs}
            className="ml-4"
          >
            Limpiar
          </Button>
        )}
      </div>

      {isExpanded && (
        <div className="space-y-2 max-h-96 overflow-y-auto">
          {logs.length === 0 ? (
            <p className="text-gray-500 text-center py-4">No hay logs disponibles</p>
          ) : (
            logs.map((log, index) => (
              <div
                key={index}
                className={`p-3 rounded-md text-sm ${getLogColor(log.level)}`}
              >
                <div className="flex items-start gap-2">
                  <Icon 
                    name={getLogIcon(log.level) as any} 
                    className="w-4 h-4 mt-0.5 flex-shrink-0" 
                  />
                  <div className="flex-1">
                    <div className="flex items-center justify-between">
                      <span className="font-medium">{log.message}</span>
                      <span className="text-xs opacity-75">
                        {formatTimestamp(log.timestamp)}
                      </span>
                    </div>
                    {log.data && (
                      <pre className="mt-1 text-xs opacity-75 overflow-x-auto">
                        {JSON.stringify(log.data, null, 2)}
                      </pre>
                    )}
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      )}
    </Card>
  );
};